import { ITranslations } from 'types/common';
import { PointScheduleTableTransFields } from './types';
import en from 'translations/en/pointScheduleTable.json';
import pl from 'translations/pl/pointScheduleTable.json';
import sl from 'translations/sl/pointScheduleTable.json';

export const pointScheduleTableTranslations: ITranslations<PointScheduleTableTransFields> = {
  name: 'pointScheduleTable',
  en,
  pl,
  sl,
};
